import { Storybook } from "@tento-ui/ui/storybook";
import { DshTurnNote } from "./note";

export class DshTurnNoteStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · dsh · note (two faces)";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "text[active] — the shimmer, at the same size as everything",
        render: () =>
          DshTurnNote.makeWith({
            face: "text",
            text: "Distilling the transcript…",
            active: true,
          }),
      },
      {
        title: "The two side by side — live, then settled",
        render: () => {
          const $wrap = column();
          $wrap.append(
            DshTurnNote.makeWith({
              face: "text",
              text: "Reading 41 files…",
              active: true,
            }),
            DshTurnNote.makeWith({
              face: "text",
              text: "rebuilding after the duplicate declaration",
            }),
          );
          return $wrap;
        },
      },
      {
        title: "text — a session meta event, which is not working on anything",
        render: () =>
          DshTurnNote.makeWith({
            face: "text",
            text: "mode: plan · model opus",
          }),
      },
      {
        title: "text — a long line ellipsises rather than wrapping",
        render: () =>
          DshTurnNote.makeWith({
            face: "text",
            text:
              "Compacting the context window — 41 messages coalesced into one summary, retaining the last 8 turns verbatim and every unresolved verdict",
            active: true,
          }),
      },
      {
        title: "rule — a bare one is 16px of nothing, between two lines",
        render: () => {
          const $wrap = column();
          $wrap.append(
            DshTurnNote.makeWith({ face: "text", text: "session · commands · 57" }),
            DshTurnNote.makeWith({ face: "rule" }),
            DshTurnNote.makeWith({ face: "text", text: "session · commands · 58" }),
          );
          return $wrap;
        },
      },
      {
        title: "rule — labelled, and only then does it take a line",
        render: () => DshTurnNote.makeWith({ face: "rule", label: "retry" }),
      },
    ];
  }
}

function column(): HTMLElement {
  const $wrap = document.createElement("div");
  $wrap.style.display = "flex";
  $wrap.style.flexDirection = "column";
  $wrap.style.gap = "2px";
  $wrap.style.width = "100%";
  return $wrap;
}
